export const QUERY_KEY = {
  COMPARISON: 'supply_shed_comparison',
  SUPPLY_SHED: 'supply_shed',
  SUPPLY_SHEDS_PAGINATED: 'supply_sheds_paginated',
}
